import { css } from 'emotion'

export const ResetPasswordFormStyles = css`
  .TextInputField {
    margin-top: 32px;
  }
`
